import React from 'react';
import { Link } from 'react-router-dom';
import '../OtherVideos/other.css';

function Colour() {
  return (
    <div className="charlie-page">
      <h1 className="charlie-title">🎨 Coloring & Art Resources</h1>

      <div className="charlie-table-container">
        <table className="charlie-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Resource / Art Form</th>
              <th>Key Features</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {colourData.map((item, index) => (
              <tr key={index}>
                <td>{item.scene}</td>
                <td>{item.themes}</td>
                <td>{item.interpretation}</td>
                <td>
                  <iframe
                    className="charlie-iframe"
                    src={item.video}
                    title={item.scene}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/zones" className="back-button">
          ⬅ Back to Museum Realms
        </Link>
      </div>
    </div>
  );
}

const colourData = [
  {
    scene: "Printable Coloring Pages",
    themes: "Pitara Kids Network",
    interpretation: "Free printable sheets: animals, festivals (Diwali, Ganesha), village scenes",
    video: "https://www.youtube-nocookie.com/embed/Eo4BWyNZy7Y?rel=0&modestbranding=1"
  },
  {
    scene: "Printable Coloring Pages",
    themes: "Pitara – Festivals",
    interpretation: "Themed pages for Diwali, Holi, Christmas, Eid",
    video: "https://www.youtube-nocookie.com/embed/k9blcVpVSHs?rel=0&modestbranding=1"
  },
  {
    scene: "Printable Coloring Pages",
    themes: "Pitara – Village & Dance Art",
    interpretation: "Traditional dancers and rural life scenes",
    video: "https://www.youtube-nocookie.com/embed/wy6tp4yzx8Y?rel=0&modestbranding=1"
  },
  {
    scene: "Online Interactive Tools",
    themes: "HappyPagesAI (AI coloring pages)",
    interpretation: "AI-based customizable coloring page generator—create unique designs",
    video: "https://www.youtube-nocookie.com/embed/DlTt9C_eLrI?rel=0&modestbranding=1"
  },
  {
    scene: "Digital Art Tutorials",
    themes: "CAMI (Children’s Art Museum of India)",
    interpretation: "Video tutorials: charcoal horse, acrylic skies, Ganesha, zentangles—beginner friendly",
    video: "https://www.youtube.com/embed/@Camierdne"
  },
  {
    scene: "Digital Art Tutorials",
    themes: "— Misty Forest Charcoal",
    interpretation: "Shaded monochromatic nature drawing tutorial",
    video: "https://www.youtube-nocookie.com/embed/2fDwWMmVMHs?rel=0&modestbranding=1"
  },
  {
    scene: "Digital Art Tutorials",
    themes: "— Zentangles in Bamboo",
    interpretation: "Relaxing pattern art, improving focus and creativity",
    video: "https://www.youtube-nocookie.com/embed/r9JkOShTCBY?rel=0&modestbranding=1"
  },
  {
    scene: "Traditional Art Forms",
    themes: "Warli Painting (CAMI tutorial)",
    interpretation: "Easy warli tribal painting—poster colors and patterns",
    video: "https://www.youtube-nocookie.com/embed/VwWtd2qfq0U?rel=0&modestbranding=1"
  },
  {
    scene: "Traditional Art Forms",
    themes: "Kolam Art (Pitara)",
    interpretation: "Step-by-step Kolam drawing—South Indian floor art with rice powder grids",
    video: "https://www.youtube-nocookie.com/embed/uaXeY-4RTYk?rel=0&modestbranding=1"
  },
  {
    scene: "Online Art Classes (India)",
    themes: "Dessin Academy, Chennai",
    interpretation: "Structured classes—pencil, watercolor, acrylic, charcoal, poster art for kids & adults",
    video: "https://www.youtube-nocookie.com/embed/6j7PGQeRA3c?rel=0&modestbranding=1"
  },
  {
    scene: "Online Art Classes (India)",
    themes: "A For Arts, Chennai",
    interpretation: "Online painting, rangoli, jewelry-making, traditional crafts",
    video: "https://www.youtube-nocookie.com/embed/2sH2KCTtFlg?rel=0&modestbranding=1"
  }
];

export default Colour;
